import { MessageAttachedFile } from 'lib-shared-legacy-types';

import { PrivateMediaPlayer } from 'components/privateMediaPlayer';

import { AttachmentType } from '../../../utils/attachment';

type StoryVideoProps = {
  readonly attachment: MessageAttachedFile;
  readonly type: AttachmentType;
  readonly onError: () => void;
};

export const StoryVideo = ({
  attachment: { url: src, pretty_name },
  type,
  onError,
}: StoryVideoProps): JSX.Element => {
  return (
    <PrivateMediaPlayer
      controls={{ download: false }}
      mediaFile={{ src, type }}
      filename={pretty_name}
      onError={onError}
    />
  );
};
